import { MdsSkeletonLoaderShape } from "@/design-system/components/loader/types";
import { MdsSkeletonLoader } from "@/design-system/components/loader/MdsSkeletonLoader";

import styled from "@emotion/styled";

export const IntegrationsLoader = () => {
  return (
    <SkeletonWrapper>
      <ContentSkeleton>
        <SectionSkeleton>
          <MdsSkeletonLoader height={16} width={220} shape={MdsSkeletonLoaderShape.Rectangle} />
          <BlockSkeleton>
            <MdsSkeletonLoader height={60} width={60} shape={MdsSkeletonLoaderShape.Rectangle} />
            <MdsSkeletonLoader height={60} width={600} shape={MdsSkeletonLoaderShape.Rectangle} />
          </BlockSkeleton>
          <BlockSkeleton>
            <MdsSkeletonLoader height={60} width={60} shape={MdsSkeletonLoaderShape.Rectangle} />
            <MdsSkeletonLoader height={60} width={600} shape={MdsSkeletonLoaderShape.Rectangle} />
          </BlockSkeleton>
        </SectionSkeleton>
      </ContentSkeleton>
    </SkeletonWrapper>
  );
};

const SkeletonWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  margin: `22px 0`,
});

const ContentSkeleton = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "32px",
});

const SectionSkeleton = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  alignItems: "flex-start",
});

const BlockSkeleton = styled.div({
  display: "flex",
  flexDirection: "row",
  gap: "16px",
});
